export const OFFSET_LIMIT_PAGINATION = 20;

export const BUTTON_TEXT = 'Показать ещё';

export const DIRECTION_NEXT_TYPE = 'next';
export const DIRECTION_NEXT_VALUE = 'Вперед';

export const DIRECTION_PREV_TYPE = 'prev';
export const DIRECTION_PREV_VALUE = 'Назад';
